import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import _ from "lodash";
import Select from "components/select/Select";
import StripeCheckout from "react-stripe-checkout";
import classNames from "classnames";
import { toastr } from "react-redux-toastr";
import immutable from "object-path-immutable";
import { formatISO } from "date-fns";

import {
  getGenderOptions,
  getRawOrEquippedOptions,
  getAwardDivisionOptions,
  getWeightClassOptions,
  getStateOptions,
  getTeamOptions,
} from "util/options";
import {
  generateId,
  LIFTER_DOC_PREFIX,
  RESTRICTED_LIFTER_DOC_PREFIX,
  DOC_PARENT_SEPARATOR,
  ATTEMPT_DOC_PREFIX,
} from "util/docHelper";
import { getStateLabel, getDateFormat } from "util/meetHelper";
import { reformatDateToUsFormat } from "util/dateHelper";
import { getDivisionDoc } from "util/lifterHelper";
import { fetchWrapper } from "util/api";
import DateInput from "components/dateInput/DateInput";

import DeleteIcon from "icons/DeleteIcon";

import "./RegistrationIndex.scss";

import { getCurrentMeet, getIsLocal, getIsOnline } from "selectors";

class RegistrationIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      complete: false,
      processing: false,
      apiError: "",
      cardCharged: false,
      _id: generateId(LIFTER_DOC_PREFIX),
      name: "",
      memberNumber: "",
      phoneNumber: "",
      streetAddress: "",
      city: "",
      state: "",
      zipCode: "",
      email: "",
      emailConfirm: "",
      birthDate: "",
      gender: null,
      team: null,
      divisions: [
        {
          rawOrEquipped: props.meet.federation === "USSF" ? "RAW" : null,
          divisionId: null,
          declaredAwardsWeightClassId: null,
        },
      ],
      items: [],
      emergencyContactName: "",
      emergencyContactPhoneNumber: "",
      disclaimerAgreed: "",
      errors: {},
    };
  }

  addDivision = () => {
    const newDivisions = [
      ...this.state.divisions,
      {
        rawOrEquipped: this.props.meet.federation === "USSF" ? "RAW" : null,
        divisionId: null,
        declaredAwardsWeightClassId: null,
      },
    ];
    this.setState({ divisions: newDivisions });
  };

  addItem = () => {
    const newItems = [...this.state.items, null];
    this.setState({ items: newItems });
  };

  removeDivision = (index) => {
    this.setState({
      divisions: _.reject(this.state.divisions, (value, i) => i === index),
    });
  };

  handleDivisionChange = (index, name, value) => {
    const newDivisions = immutable.set(
      this.state.divisions,
      [index, name],
      value
    );
    this.setState({ divisions: newDivisions });
  };

  handleItemChange = (index, value) => {
    const newItems = immutable.set(this.state.items, [index], value);
    this.setState({ items: newItems });
  };

  handleItemRemove = (index) => {
    const newItems = [...this.state.items];
    newItems.splice(index, 1);
    this.setState({ items: newItems });
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onToken = (token) => {
    const createDate = formatISO(new Date());
    this.setState({ processing: true });
    window.scrollTo(0, 0);
    const lifterId = this.state._id;

    const lifter = {
      _id: lifterId,
      name: this.state.name,
      state: this.state.state,
      birthDate: this.state.birthDate,
      gender: this.state.gender,
      team: this.state.team,
      divisions: this.state.divisions,
      createDate,
    };

    if (this.props.meet.virtualMeet) {
      lifter.platformId = _.first(Object.keys(this.props.meet.platforms), 0);
      lifter.session = 1;
      lifter.flight = "A";
    }

    const restrictedLifter = {
      _id: `${generateId(
        RESTRICTED_LIFTER_DOC_PREFIX
      )}${DOC_PARENT_SEPARATOR}${lifterId}`,
      memberNumber: this.state.memberNumber,
      phoneNumber: this.state.phoneNumber,
      streetAddress: this.state.streetAddress,
      city: this.state.city,
      zipCode: this.state.zipCode,
      email: this.state.email,
      items: this.state.items,
      emergencyContactName: this.state.emergencyContactName,
      emergencyContactPhoneNumber: this.state.emergencyContactPhoneNumber,
      createDate,
    };

    _.each(this.props.meet.entryConfig.customQuestions, (question) => {
      restrictedLifter[question.id] = this.state[question.id];
    });

    const body = {
      stripeToken: token,
      lifter,
      restrictedLifter,
      totalCost: this.getTotalCostInCents(),
      attempts: [
        {
          _id: `${ATTEMPT_DOC_PREFIX}1s${DOC_PARENT_SEPARATOR}${lifterId}`,
          liftName: "squat",
          attemptNumber: "1",
          lifterId: lifter._id,
          createDate,
        },
        {
          _id: `${ATTEMPT_DOC_PREFIX}2s${DOC_PARENT_SEPARATOR}${lifterId}`,
          liftName: "squat",
          attemptNumber: "2",
          lifterId: lifter._id,
          createDate,
        },
        {
          _id: `${ATTEMPT_DOC_PREFIX}3s${DOC_PARENT_SEPARATOR}${lifterId}`,
          liftName: "squat",
          attemptNumber: "3",
          lifterId: lifter._id,
          createDate,
        },
        {
          _id: `${ATTEMPT_DOC_PREFIX}1b${DOC_PARENT_SEPARATOR}${lifterId}`,
          liftName: "bench",
          attemptNumber: "1",
          lifterId: lifter._id,
          createDate,
        },
        {
          _id: `${ATTEMPT_DOC_PREFIX}2b${DOC_PARENT_SEPARATOR}${lifterId}`,
          liftName: "bench",
          attemptNumber: "2",
          lifterId: lifter._id,
          createDate,
        },
        {
          _id: `${ATTEMPT_DOC_PREFIX}3b${DOC_PARENT_SEPARATOR}${lifterId}`,
          liftName: "bench",
          attemptNumber: "3",
          lifterId: lifter._id,
          createDate,
        },
        {
          _id: `${ATTEMPT_DOC_PREFIX}1d${DOC_PARENT_SEPARATOR}${lifterId}`,
          liftName: "dead",
          attemptNumber: "1",
          lifterId: lifter._id,
          createDate,
        },
        {
          _id: `${ATTEMPT_DOC_PREFIX}2d${DOC_PARENT_SEPARATOR}${lifterId}`,
          liftName: "dead",
          attemptNumber: "2",
          lifterId: lifter._id,
          createDate,
        },
        {
          _id: `${ATTEMPT_DOC_PREFIX}3d${DOC_PARENT_SEPARATOR}${lifterId}`,
          liftName: "dead",
          attemptNumber: "3",
          lifterId: lifter._id,
          createDate,
        },
      ],
    };
    fetchWrapper(`/api/meets/${this.props.meet._id}/registration`, "POST", body)
      .then((response) => {
        if (response.ok) {
          this.setState({
            processing: false,
            complete: true,
            apiError: "",
            cardCharged: response.cardCharged,
          });
        } else {
          this.setState({
            processing: false,
            apiError: response.error,
            cardCharged: response.cardCharged,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ processing: false, apiError: error });
      });
  };

  isFormValid = async () => {
    const errors = {};
    if (!this.state.name) {
      errors.name = "Name is required";
    }

    if (!/\d/.test(this.state.phoneNumber)) {
      errors.phoneNumber = "This doesn't look like a phone number.";
    }

    if (!this.state.streetAddress) {
      errors.streetAddress = "Street Address is required";
    }

    if (!this.state.city) {
      errors.city = "City is required";
    }

    if (!this.state.state) {
      errors.state = `${getStateLabel(this.props.meet)} is required`;
    }

    if (!this.state.zipCode) {
      errors.zipCode = "Zip Code is required";
    }

    if (!this.state.email) {
      errors.email = "Email is required";
    }

    if (!/\S+@\S+\.\S+/.test(this.state.email)) {
      errors.email = "Email is not valid";
    }

    if (this.state.emailConfirm !== this.state.email) {
      errors.emailConfirm = "Confirmation must match";
    }

    if (!this.state.birthDate) {
      errors.birthDate = "Birth Date is required";
    }

    if (!this.state.gender) {
      errors.gender = "Gender is required";
    }

    if (!this.state.emergencyContactName) {
      errors.emergencyContactName = "Emergency contact is required";
    }

    if (!/\d/.test(this.state.emergencyContactPhoneNumber)) {
      errors.emergencyContactPhoneNumber =
        "This doesn't look like a phone number.";
    }

    if (
      this.props.meet.entryConfig.disclaimer &&
      this.state.disclaimerAgreed !== "I AGREE"
    ) {
      errors.disclaimerAgreed = 'You must type "I AGREE" exactly.';
    }

    _.each(this.state.divisions, (division, index) => {
      if (!division.rawOrEquipped) {
        _.set(
          errors,
          ["divisions", index, "rawOrEquipped"],
          "Raw or equipped is required."
        );
      }
      if (!division.divisionId) {
        _.set(
          errors,
          ["divisions", index, "divisionId"],
          "Division name is required."
        );
      }
      if (!division.declaredAwardsWeightClassId) {
        _.set(
          errors,
          ["divisions", index, "declaredAwardsWeightClassId"],
          "Declared weight class is required."
        );
      }
    });

    _.each(this.props.meet.entryConfig.customQuestions, (question) => {
      if (question.required && !this.state[question.id]) {
        errors[question.id] = "Required";
      }
    });

    if (
      _.isEmpty(errors) &&
      this.props.meet.entryConfig.requireValidMemberNumbers
    ) {
      return this.checkMembership(errors);
    }

    return Promise.resolve(errors);
  };

  checkMembership = (errors) => {
    const memberNumber = this.state.memberNumber;
    const name = this.state.name;
    const birthDate = this.state.birthDate;
    const formattedBirthDate = reformatDateToUsFormat({
      dateString: birthDate,
      meet: this.props.meet,
    });
    const state = this.state.state;
    return fetchWrapper(
      `/api/check_membership?member_number=${memberNumber}&state=${state}&name=${name}&birth_date=${formattedBirthDate}`,
      "GET"
    )
      .then((response) => {
        if (response.error === "Not Found") {
          errors.memberNumber = "Membership Number not found in USAPL Database";
        } else if (response.error) {
          errors.memberNumber = response.error;
        } else if (!response.name_match && !response.name_suggestion) {
          errors.memberNumber = "Name does not match membership card.";
        } else if (!response.birth_date_match) {
          errors.memberNumber = "Birth date does not match membership card.";
        }
        return errors;
      })
      .catch((error) => {
        console.error(error);
        errors.memberNumber =
          "Unable to verify member number. Please try again later.";
        return errors;
      });
  };

  getTotalCostInCents = () => {
    const { meet } = this.props;
    let totalInCents = 0;
    // make sure full lift divisions are at the top so that the lifter is charged the max amount
    // this assumes the meet director sets up full power division to be more expensive
    const divisions = _.sortBy(this.state.divisions, (division) => {
      const divisionDoc = getDivisionDoc(division.divisionId, meet);
      if (divisionDoc) {
        if (
          divisionDoc.lifts.squat &&
          divisionDoc.lifts.bench &&
          divisionDoc.lifts.dead
        ) {
          return 1;
        } else {
          return 2;
        }
      } else {
        return 3;
      }
    });

    _.each(divisions, (division, index) => {
      const divisionDoc = getDivisionDoc(division.divisionId, meet);
      if (divisionDoc) {
        if (index === 0) {
          if (
            divisionDoc.lifts.squat &&
            divisionDoc.lifts.bench &&
            divisionDoc.lifts.dead
          ) {
            totalInCents += (meet.entryConfig.fullPowerliftingCost || 0) * 100;
          } else {
            totalInCents +=
              (meet.entryConfig.oneTwoLiftCost ||
                meet.entryConfig.fullPowerliftingCost ||
                0) * 100;
          }
        } else {
          totalInCents += (meet.entryConfig.additionalDivisionCost || 0) * 100;
        }
      }
    });

    _.each(this.state.items, (itemId) => {
      const itemFromConfig = _.find(
        meet.entryConfig.items,
        (i) => i.id === itemId
      );
      if (itemFromConfig) {
        totalInCents += (itemFromConfig.cost || 0) * 100;
      }
    });

    return totalInCents;
  };

  openStripeModal = async () => {
    const errors = await this.isFormValid();
    this.setState({ errors });
    if (_.isEmpty(errors)) {
      this.stripeButtonRef.click();
      return true;
    }

    toastr.error("Please fix issues");
    return false;
  };

  renderMeetInfo = () => {
    const { meet } = this.props;

    return (
      <div className="meet-info">
        <div>{meet.entryConfig.description}</div>
        <div className="website-link">
          <a href={meet.entryConfig.website}>{meet.entryConfig.website}</a>
        </div>
      </div>
    );
  };

  render() {
    const { meet, isLocal, isOnline } = this.props;

    const limitedGenderOptions = _.filter(
      getGenderOptions(null, meet),
      (option) => {
        return _.find(meet.divisions, { gender: option.value });
      }
    );

    const missingDivisions = _.isEmpty(limitedGenderOptions);

    const setupIncomplete =
      (isLocal && !isOnline) ||
      !meet.entryConfig.stripePublicKey ||
      !meet.entryConfig.fullPowerliftingCost ||
      !meet.entryConfig.maxEntries ||
      missingDivisions;

    if (this.state.complete) {
      window.scrollTo(0, 0);
      return (
        <div className="registration-index">
          <div className="message">
            Registration accepted.{" "}
            <Link to={`/meets/${meet._id}/roster`}>
              You can find your name on the roster here.
            </Link>
          </div>
        </div>
      );
    }

    if (!meet.entryConfig.isOpen) {
      window.scrollTo(0, 0);
      return (
        <div className="registration-index">
          {this.renderMeetInfo()}
          <div className="message">Registration is currently closed.</div>
        </div>
      );
    }

    if (_.size(meet.lifters) >= meet.entryConfig.maxEntries) {
      window.scrollTo(0, 0);
      return (
        <div className="registration-index">
          {this.renderMeetInfo()}
          <div className="message">
            This meet has reached capacity. Registration is now closed.
          </div>
        </div>
      );
    }

    const itemOptions = _.map(meet.entryConfig.items, (i) => {
      return {
        label: `${i.name} - $${i.cost}`,
        value: i.id,
      };
    });

    const teamOptions = getTeamOptions(this.state, meet);
    if (this.state.team && !_.find(teamOptions, { value: this.state.team })) {
      teamOptions.push({ value: this.state.team, label: this.state.team });
    }

    return (
      <div className="registration-index">
        {this.state.processing && (
          <div>
            <div className="processing-overlay" />
            <div className="processing-spinner">
              <div className="loader" />
            </div>
          </div>
        )}
        {this.state.apiError && (
          <div className="api-error">
            <div>There was an error processing your request.</div>
            {!this.state.cardCharged && <div>Your card was not charged.</div>}
            <div>{this.state.apiError}</div>
          </div>
        )}

        {setupIncomplete && isLocal && (
          <div className="api-error">
            <div>Registration Setup Incomplete.</div>
            {!isOnline && <div>Must be uploaded to cloud.</div>}
            {!meet.entryConfig.stripePublicKey && (
              <div>Missing stripe key.</div>
            )}
            {!meet.entryConfig.fullPowerliftingCost && (
              <div>Missing full powerlifting cost.</div>
            )}
            {!meet.entryConfig.maxEntries && <div>Missing max entries.</div>}
            {missingDivisions && <div>Missing awards divisions.</div>}
          </div>
        )}

        {this.renderMeetInfo()}

        <div className="entry-row">
          <label>Full Name as it appears on membership card *</label>
          <div className="input-wrapper">
            <input
              type="text"
              className={classNames({ error: this.state.errors.name })}
              value={this.state.name}
              onChange={(e) => this.handleChange("name", e.target.value)}
            />
            <div className="error-message">{this.state.errors.name}</div>
          </div>
        </div>
        <div className="entry-row">
          <label>
            Membership Number{" "}
            {meet.entryConfig.requireValidMemberNumbers && "*"}
          </label>
          <div className="input-wrapper">
            <input
              type="text"
              value={this.state.memberNumber}
              onChange={(e) =>
                this.handleChange("memberNumber", e.target.value)
              }
            />
            <div className="error-message">
              {this.state.errors.memberNumber}
            </div>
          </div>
        </div>
        <div className="entry-row">
          <label>Phone Number *</label>
          <div className="input-wrapper">
            <input
              type="text"
              className={classNames({ error: this.state.errors.phoneNumber })}
              value={this.state.phoneNumber}
              onChange={(e) => this.handleChange("phoneNumber", e.target.value)}
            />
            <div className="error-message">{this.state.errors.phoneNumber}</div>
          </div>
        </div>
        <div className="entry-row">
          <label>Street Address *</label>
          <div className="input-wrapper">
            <input
              type="text"
              className={classNames({ error: this.state.errors.streetAddress })}
              value={this.state.streetAddress}
              onChange={(e) =>
                this.handleChange("streetAddress", e.target.value)
              }
            />
            <div className="error-message">
              {this.state.errors.streetAddress}
            </div>
          </div>
        </div>
        <div className="entry-row">
          <label>City *</label>
          <div className="input-wrapper">
            <input
              type="text"
              className={classNames({ error: this.state.errors.city })}
              value={this.state.city}
              onChange={(e) => this.handleChange("city", e.target.value)}
            />
            <div className="error-message">{this.state.errors.city}</div>
          </div>
        </div>
        <div className="entry-row">
          <label>{getStateLabel(meet)} *</label>
          <div className="input-wrapper">
            <Select
              className={classNames({ error: this.state.errors.state })}
              value={this.state.state}
              options={getStateOptions(null, meet)}
              onChange={(value) => this.handleChange("state", value)}
              clearable={false}
            />
            <div className="error-message">{this.state.errors.state}</div>
          </div>
        </div>
        <div className="entry-row">
          <label>Zip Code *</label>
          <div className="input-wrapper">
            <input
              type="text"
              className={classNames({ error: this.state.errors.zipCode })}
              value={this.state.zipCode}
              onChange={(e) => this.handleChange("zipCode", e.target.value)}
            />
            <div className="error-message">{this.state.errors.zipCode}</div>
          </div>
        </div>
        <div className="entry-row">
          <label>Email Address *</label>
          <div className="input-wrapper">
            <input
              type="email"
              className={classNames({ error: this.state.errors.email })}
              value={this.state.email}
              onChange={(e) => this.handleChange("email", e.target.value)}
            />
            <div className="error-message">{this.state.errors.email}</div>
          </div>
        </div>
        <div className="entry-row">
          <label>Confirm Email Address *</label>
          <div className="input-wrapper">
            <input
              type="email"
              className={classNames({ error: this.state.errors.emailConfirm })}
              value={this.state.emailConfirm}
              onChange={(e) =>
                this.handleChange("emailConfirm", e.target.value)
              }
            />
            <div className="error-message">
              {this.state.errors.emailConfirm}
            </div>
          </div>
        </div>
        <div className="entry-row">
          <label>Birth Date *</label>
          <div className="input-wrapper">
            <DateInput
              dateFormat={getDateFormat(meet)}
              className={classNames({ error: this.state.errors.birthDate })}
              value={this.state.birthDate}
              onChange={(v) => this.handleChange("birthDate", v)}
              placeholder={getDateFormat(meet)}
            />
            <div className="error-message">{this.state.errors.birthDate}</div>
          </div>
        </div>
        <div className="entry-row">
          <label>Gender *</label>
          <div className="input-wrapper">
            <Select
              className={classNames({ error: this.state.errors.gender })}
              value={this.state.gender}
              options={limitedGenderOptions}
              onChange={(value) => this.handleChange("gender", value)}
              clearable={false}
            />
            <div className="error-message">{this.state.errors.gender}</div>
          </div>
        </div>
        <div className="entry-row">
          <label>Emergency Contact Name *</label>
          <div className="input-wrapper">
            <input
              type="text"
              className={classNames({
                error: this.state.errors.emergencyContactName,
              })}
              value={this.state.emergencyContactName}
              onChange={(e) =>
                this.handleChange("emergencyContactName", e.target.value)
              }
            />
            <div className="error-message">
              {this.state.errors.emergencyContactName}
            </div>
          </div>
        </div>
        <div className="entry-row">
          <label>Emergency Contact Phone Number *</label>
          <div className="input-wrapper">
            <input
              type="text"
              className={classNames({
                error: this.state.errors.emergencyContactPhoneNumber,
              })}
              value={this.state.emergencyContactPhoneNumber}
              onChange={(e) =>
                this.handleChange("emergencyContactPhoneNumber", e.target.value)
              }
            />
            <div className="error-message">
              {this.state.errors.emergencyContactPhoneNumber}
            </div>
          </div>
        </div>
        <div className="entry-row">
          <label>Team</label>
          <div className="input-wrapper">
            <Select
              className={classNames({ error: this.state.errors.team })}
              value={this.state.team}
              options={teamOptions}
              onChange={(value) => this.handleChange("team", value)}
              allowCreate
              name="team"
            />
            <div className="error-message">{this.state.errors.team}</div>
          </div>
        </div>

        {_.map(meet.entryConfig.customQuestions, (question) => {
          return (
            <div className="entry-row" key={question.id}>
              <label>
                {question.text} {question.required && <span>*</span>}
              </label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className={classNames({
                    error: this.state.errors[question.id],
                  })}
                  value={this.state[question.id] || ""}
                  onChange={(e) =>
                    this.handleChange(question.id, e.target.value)
                  }
                />
                <div className="error-message">
                  {this.state.errors[question.id]}
                </div>
              </div>
            </div>
          );
        })}

        <div className="divisions-title">
          Division{meet.entryConfig.additionalDivisionCost && "s"}
        </div>
        {_.map(this.state.divisions, (division, index) => {
          const limitedRawOrEquippedOptions = _.filter(
            getRawOrEquippedOptions(null, meet),
            (option) => {
              return _.find(meet.divisions, {
                gender: this.state.gender,
                rawOrEquipped: option.value,
              });
            }
          );

          const enabledDivisionOptions = _.map(
            getAwardDivisionOptions(this.state, meet, index),
            (divisionOption) => {
              if (
                _.find(
                  this.state.divisions,
                  (d) => d.divisionId === divisionOption.value
                )
              ) {
                return { ...divisionOption, disabled: true };
              } else {
                return divisionOption;
              }
            }
          );

          return (
            <div className="division-box" key={index}>
              {meet.entryConfig.additionalDivisionCost && (
                <div className="division-count">
                  Division {index + 1}
                  {index !== 0 && (
                    <button onClick={() => this.removeDivision(index)}>
                      Remove
                    </button>
                  )}
                </div>
              )}
              {meet.federation !== "USSF" && (
                <div className="entry-row">
                  <label>Raw or Equipped *</label>
                  <div className="input-wrapper">
                    <Select
                      className={classNames({
                        error: _.get(this.state.errors, [
                          "divisions",
                          index,
                          "rawOrEquipped",
                        ]),
                      })}
                      value={division.rawOrEquipped}
                      options={limitedRawOrEquippedOptions}
                      onChange={(value) =>
                        this.handleDivisionChange(index, "rawOrEquipped", value)
                      }
                      clearable={false}
                      disabled={!this.state.gender}
                    />
                    <div className="error-message">
                      {_.get(this.state.errors, [
                        "divisions",
                        index,
                        "rawOrEquipped",
                      ])}
                    </div>
                  </div>
                </div>
              )}
              <div className="entry-row">
                <label>Division Name *</label>
                <div className="input-wrapper">
                  <Select
                    className={classNames({
                      error: _.get(this.state.errors, [
                        "divisions",
                        index,
                        "divisionId",
                      ]),
                    })}
                    value={division.divisionId}
                    options={enabledDivisionOptions}
                    onChange={(value) =>
                      this.handleDivisionChange(index, "divisionId", value)
                    }
                    clearable={false}
                    disabled={
                      !this.state.gender ||
                      !this.state.divisions[index].rawOrEquipped
                    }
                  />
                  <div className="error-message">
                    {_.get(this.state.errors, [
                      "divisions",
                      index,
                      "divisionId",
                    ])}
                  </div>
                </div>
              </div>
              <div className="entry-row">
                <label>Declared Weight Class *</label>
                <div className="input-wrapper">
                  <Select
                    className={classNames({
                      error: _.get(this.state.errors, [
                        "divisions",
                        index,
                        "declaredAwardsWeightClassId",
                      ]),
                    })}
                    value={division.declaredAwardsWeightClassId}
                    options={getWeightClassOptions(this.state, meet, index)}
                    onChange={(value) =>
                      this.handleDivisionChange(
                        index,
                        "declaredAwardsWeightClassId",
                        value
                      )
                    }
                    clearable={false}
                    disabled={!this.state.divisions[index].divisionId}
                  />
                  <div className="error-message">
                    {_.get(this.state.errors, [
                      "divisions",
                      index,
                      "declaredAwardsWeightClassId",
                    ])}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {meet.entryConfig.additionalDivisionCost && (
          <div className="add-division">
            <button onClick={this.addDivision}>Add Division</button>
          </div>
        )}

        {!_.isEmpty(meet.entryConfig.items) && (
          <div>
            <div className="items-title">Additional Items</div>
            <div className="items-subtitle">
              Click "Add Item" to purchase t-shirts or other items. Then select
              an item from the dropdown.
            </div>
            <table className="item-table">
              <tbody>
                {_.map(this.state.items, (itemId, index) => {
                  return (
                    <tr key={index} className="item-row">
                      <td>
                        <Select
                          value={itemId}
                          options={itemOptions}
                          onChange={(value) =>
                            this.handleItemChange(index, value)
                          }
                          clearable={false}
                        />
                      </td>
                      <td>
                        <button onClick={() => this.handleItemRemove(index)}>
                          <DeleteIcon />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <button onClick={this.addItem}>Add Item</button>
          </div>
        )}

        {meet.entryConfig.disclaimer && (
          <div>
            <div className="disclaimer-title">Disclaimer</div>
            <div className="disclaimer-text">{meet.entryConfig.disclaimer}</div>
            <div className="entry-row">
              <label>You must type "I AGREE" *</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className={classNames({
                    error: this.state.errors.disclaimerAgreed,
                  })}
                  value={this.state.disclaimerAgreed}
                  onChange={(e) =>
                    this.handleChange("disclaimerAgreed", e.target.value)
                  }
                />
                <div className="error-message">
                  {this.state.errors.disclaimerAgreed}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="total">
          Total: ${(this.getTotalCostInCents() / 100).toFixed(2)}
        </div>

        {setupIncomplete && (
          <button className="pay-button">Registration Setup Incomplete</button>
        )}
        {!setupIncomplete && (
          <button className="pay-button" onClick={this.openStripeModal}>
            Pay with card
          </button>
        )}

        <StripeCheckout
          token={this.onToken}
          amount={this.getTotalCostInCents()}
          ComponentClass="div"
          stripeKey={meet.entryConfig.stripePublicKey}
          name="LiftingCast"
          description={meet.name}
          currency="USD"
          email={this.state.email}
          allowRememberMe={false}
        >
          <button
            style={{ display: "none" }}
            ref={(ref) => (this.stripeButtonRef = ref)}
          >
            Pay with card
          </button>
        </StripeCheckout>

        {this.state.apiError && (
          <div className="api-error">
            <div>There was an error processing your request.</div>
            {!this.state.cardCharged && <div>Your card was not charged.</div>}
            <div>{this.state.apiError}</div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    isLocal: getIsLocal(state, props),
    isOnline: getIsOnline(state, props),
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(RegistrationIndex);
